import React from 'react';
interface CtaButtonProps {
  children: React.ReactNode;
  variant?: 'primary' | 'lime' | 'outline';
  className?: string;
  href?: string;
  onClick?: () => void;
}
export function CtaButton({
  children,
  variant = 'primary',
  className = '',
  href,
  onClick
}: CtaButtonProps) {
  const base = 'inline-flex min-h-[52px] items-center justify-center gap-2.5 rounded-full px-7 py-4 text-sm font-extrabold uppercase tracking-wide transition-colors duration-150 focus:outline-none focus-visible:ring-2 focus-visible:ring-lime focus-visible:ring-offset-2 focus-visible:ring-offset-ink sm:text-base';
  const styles = {
    primary: 'bg-ink text-snow shadow-[0_10px_26px_rgba(0,0,0,0.32)] hover:bg-ink-soft',
    lime: 'bg-lime text-ink shadow-[0_10px_26px_rgba(217,189,138,0.26)] hover:bg-lime-soft',
    outline: 'border-2 border-snow/70 text-snow hover:border-lime hover:text-lime'
  }[variant];
  if (href) {
    return <a href={href} className={`${base} ${styles} ${className}`} data-id="element-11" data-mp="15b14o2tv3irq">
        {children}
      </a>;
  }
  return <button type="button" onClick={onClick} className={`${base} ${styles} ${className}`} data-id="element-12" data-mp="35z8xyv2945mi">
      {children}
    </button>;
}